import ChangeBaseLineAPIServices from 'api/ChangeBaseLineAPIServices';
import { SearchParams } from 'api/ResourceAPI';
import useApi from 'hooks/useApi';
import { useCallback, useRef } from 'react';
import {
  injectDashboardOrdersAction,
  setDashboardOrderFilterAction,
  setKpiMetricGridDataAction,
} from 'store/actions/dashboardActions';
import { updateItemsFilterAction } from 'store/actions/filterActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import { SelectedFiltersList } from 'types/models/SelectedFiltersList';
import { addLoadingAction, removeLoadingAction } from 'store/actions/loadingsActions';
import Order from 'types/entities/Order';
import UserApiService from 'api/UserApiService';

export default function DashboardTabServices() {
  const { makeCall } = useApi();
  const { dispatch } = useAppState();

  const fetchDashboardTodoFilter = useCallback(async () => {
    try {
      const data = await makeCall(
        UserApiService.fetchDashboardFilterOrder(),
        'Unable to Dashboard Orders Filter',
        'Dashboard Todo Filter'
      );
      dispatch(
        setDashboardOrderFilterAction({
          data,
        })
      );
      return { data };
    } catch (error) {
      console.error('Failed to fetch Dashboard Orders Filter', error);
      // Return null to signal an error/no data fetched
      return null;
    }
  }, [makeCall]);

  const fetchDashboardTodoGrid = useCallback(
    async (searchParams: SearchParams) => {
      try {
        const data = await makeCall(
          UserApiService.fetchDashboardOrderGrid(searchParams),
          'Unable to Dashboard Orders',
          'Dashboard Todo Orders'
        );
        dispatch(
          injectDashboardOrdersAction({
            // Use destructuring to pull out the data and ensure correct keys
            dashboard_orders: data.dashboard_orders,
            totalItems: data.totalItems,
            totalPages: data.totalPage, // NOTE: Check capitalization here (API returns totalPage, action expects totalPages)
            currentPage: data.currentPage,
          })
        );
        return { data };
      } catch (error) {
        console.error('Failed to fetch Dashboard Orders Grid data ', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const getKpiMetricSuperFilter = useCallback(
    async (data_type: number, filterSelected: SelectedFiltersList) => {
      try {
        const response = await makeCall(
          UserApiService.fetchParamsFilterKpi(data_type, filterSelected),
          'Unable to Dashboard super Filter',
          'Dashboard Dashboard super Filter'
        );
        if (response && response['super-filters']) {
          dispatch(updateItemsFilterAction(response['super-filters']));
        }
        return response?.['super-filters'] ?? null;
      } catch (error) {
        console.error('Failed to fetch Dashboard super Filter', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const fetchKpiMetricGraph = useCallback(
    async (data_type: number, filterSelected: SelectedFiltersList) => {
      try {
        const data = await makeCall(
          UserApiService.fetchKpiGraphData(data_type, filterSelected),
          'Unable to Dashboard Graph Data',
          'Dashboard Graph Data'
        );
        return data;
      } catch (error) {
        console.error('Failed to fetch Dashboard Graph Data', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const fetchKpiMetricGrid = useCallback(
    async (data_type: number, filterSelected: SelectedFiltersList) => {
      try {
        const data = await makeCall(
          UserApiService.fetchKpiGridData(data_type, filterSelected),
          'Unable to Dashboard Grid Data',
          'Dashboard Grid Data'
        );
        dispatch(
          setKpiMetricGridDataAction({
            // Use destructuring to pull out the data and ensure correct keys
            kpiMetricGridData: data?.orders?.datas,
            totalItems: data?.orders?.totalItems,
            totalPages: data?.orders?.totalPages, // NOTE: Check capitalization here (API returns totalPage, action expects totalPages)
            currentPage: data?.orders?.currentPage,
          })
        );

        return data;
      } catch (error) {
        console.error('Failed to fetch Dashboard Grid Data', error);
        // Return null to signal an error/no data fetched
        return null;
      }
    },
    [makeCall]
  );

  const downloadKpiGridExcel = useCallback(
    async (data_type: number, params: SearchParams) =>
      makeCall(UserApiService.getKpiExportExcel(data_type, params), 'Unable to export KPI Excel', 'export_kpi_excel'),
    [makeCall]
  );

  //   const handleBLTotalworkunitSearchParams = useCallback(
  //     async (pageSize: number, currentPage: number, searchParam: SearchParams, setIsLoading: any) => {
  //       if (!app.customer) {
  //         return;
  //       }
  //       // TODO add sort param
  //       let searchParams: SearchParams = {
  //         customer_id: app.customer.id,
  //         // is_archived: false,
  //         join: [
  //           'scope',
  //           'workunit',
  //           // 'mission-frequency',
  //           // 'mission-status',
  //           // 'mission-comments',
  //           // 'mission-comments.author',
  //           'mission-advancement',
  //           'consultant',
  //           // 'reviewer',
  //           // 'validator',
  //           'client',
  //           // 'order-scope',
  //           'delivery_manager',
  //         ],
  //         size: pageSize,
  //         page: currentPage ?? 0 ?? 0,
  //         ...searchParam,
  //       };

  //       if (sortBLtotalWorkunitModel.length > 0) {
  //         const { field, sort } = sortBLtotalWorkunitModel[0];

  //         let column_value = '';
  //         if (field === 'delivery_manager') {
  //           column_value = 'delivery_manager_fullname';
  //         } else if (field === 'comments') {
  //           column_value = 'mission-comments';
  //         } else if (field === 'workload') {
  //           column_value = 'charge';
  //         } else if (field === 'complexity') {
  //           column_value = 'complexity_name';
  //         } else if (field === 'amount') {
  //           column_value = 'price';
  //         } else if (field === 'deliverableDate') {
  //           column_value = 'delivery_date';
  //         } else if (field === 'forcastedDate') {
  //           column_value = 'forecast_date';
  //         } else if (field === 'scope') {
  //           column_value = 'scope_id';
  //         } else if (field === 'consultant') {
  //           column_value = 'consultant_fullname';
  //         } else if (field === 'client') {
  //           column_value = 'client_fullname';
  //         } else if (field === 'delivery_manager') {
  //           column_value = 'delivery_manager_fullname';
  //         } else if (
  //           field === 'submitted' ||
  //           field === 'dm_validation' ||
  //           field === 'client_acceptance' ||
  //           field === 'actions'
  //         ) {
  //           column_value = 'mission_advancement_id';
  //         } else if (field === 'tags') {
  //           column_value = 'label';
  //         } else if (field === 'purchase_order') {
  //           column_value = 'purchase_order_id';
  //         } else {
  //           column_value = field;
  //         }

  //         const sortParam = `${column_value}.${sort}`;
  //         searchParams = {
  //           ...searchParams,
  //           sorted: sortParam,
  //         };
  //       }
  //       await fetchOrderWorkunits(searchParams, setIsLoading);
  //     },
  //     [sortBLtotalWorkunitModel]
  //   );

  return {
    fetchDashboardTodoFilter,
    fetchDashboardTodoGrid,
    getKpiMetricSuperFilter,
    fetchKpiMetricGraph,
    fetchKpiMetricGrid,
    downloadKpiGridExcel,
  };
}
